/**
 * @file Email input type - extends String with email input type
 * @version 1.0.0
 */

import { StringInputType } from './string.js';

export const EmailInputType = {
  name: 'email',
  matches: getAttribute => getAttribute('format') === 'email',
  displayComponent: StringInputType.displayComponent,
  editComponent: {
    name: 'EmailEdit',
    extends: StringInputType.editComponent,
    methods: {
      getInputType() {
        return 'email';
      },
    },
  },
};

export default EmailInputType;
